import React, { Component, Fragment } from 'react';
import { REACT_APP_MODE, REACT_APP_LIVE_API, REACT_APP_TEST_API, REACT_APP_LOCAL_API } from '../../appSettings.json';
import './stage3-new.css';
import { updateObject } from "../../js/actions/index";
import store from "../../js/store/index";
import { VisibilityFilters } from "../../js/constants/action-types";
import { setVisibilityFilter } from "../../js/actions/index";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUndo } from '@fortawesome/free-solid-svg-icons'
import Form from 'react-bootstrap/Form'

const _nodeURL = REACT_APP_MODE === 'LIVE' ? REACT_APP_LIVE_API : REACT_APP_MODE === 'LOCAL' ? REACT_APP_LOCAL_API : REACT_APP_TEST_API;

function mapDispatchToProps(dispatch) {
  return {
    updateObject: article => dispatch(updateObject(article)),
  };
}

class Stage3New extends Component {

  constructor(props) {
    super(props);
    console.log(props);
    this.state = { appState: store.getState(), nextButtonClass: '', subheaderText: 'Help us find the right property for you', buttonText: 'Submit' };
    this.handleChange = this.handleChange.bind(this)
    this.gotoStage2 = this.gotoStage2.bind(this)
    this.submit = this.submit.bind(this)
  }

  componentDidMount() {
    if (this.state.appState.whyPad.newCustomer.existingCustomer === "1") {
      this.setState({ subheaderText: 'Thanks for coming back, help us fill in the gaps....', buttonText: 'Update' })
    }
    if (this.state.appState.whyPad.newCustomer.adviser === "" || this.state.appState.whyPad.newCustomer.financingMove === "") {
      this.setState({ nextButtonClass: 'disabledButton' })
    } else {
      this.setState({ nextButtonClass: 'activeButton' })
    }
  }

  handleChange(event) {
    if (this.state.appState.checkArray.indexOf(event.target.name) >= 0) {
      this.updateCheckbox(event.target.name, event.target.value);
    } else {
      this.setState({ [event.target.name]: event.target.value })
      this.state.appState.whyPad.newCustomer[event.target.name] = event.target.value;
    }

    if (this.state.appState.whyPad.newCustomer.adviser === "" || this.state.appState.whyPad.newCustomer.financingMove === "") {
      this.setState({ nextButtonClass: 'disabledButton' })
    } else {
      this.setState({ nextButtonClass: 'activeButton' })
    }

    console.log(this.state);
  }

  updateCheckbox(_name, _value) {
    this.setState({ _name: _value })

    if (this.state.appState.whyPad.newCustomer[_name] === parseInt(_value)) {
      this.state.appState.whyPad.newCustomer[_name] = "";
    } else {
      this.state.appState.whyPad.newCustomer[_name] = parseInt(_value);
    }
  }

  gotoStage2() {
    store.dispatch(setVisibilityFilter(VisibilityFilters.SHOW_STAGE2))
  }

  submit() {
    this.setState({
      buttonText: 'Saving form...',
      nextButtonClass: 'submittingForm'
    });

    // const data = new FormData();
    // data.append('whyData', JSON.stringify(this.state.appState.whyPad));

    const data = this.state.appState.whyPad;

    console.log("Submitting data: ");

    console.log(JSON.stringify(this.state.appState.whyPad));

    fetch(_nodeURL + 'submit', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data),
    }).then((response) => {
      response.json().then((body) => {
        console.log(body);

        if (body === 'OK') {
          this.setState({
            submitText: 'Thankyou',
            nextButtonClass: 'submittingForm'
          });
          store.dispatch(setVisibilityFilter(VisibilityFilters.SHOW_THANKYOU))
        } else {
          this.setState({
            submitText: 'Please try again',
            nextButtonClass: 'activeButton'
          });
        }
      })
    });
  }

  onSubmitForm = () => {


  }

  render() {
    return (
      <Fragment>
        <div className="row valFormWidth" style={{ background: 'transparent', padding: '20px 30px', opacity: '0.95', margin: '0 auto' }}>
          <div className="row pageHeader">
            <div className="col-md-12 col-sm-12 col-xs-12" style={{ marginTop: '10px', paddingLeft: '0px' }}>
              <label style={{ fontWeight: 'bold', marginBottom: '0px' }}>Tell us more about your move</label>
            </div>
          </div>
          <div className="row pageSubHeader">
            <div className="col-md-12 col-sm-12 col-xs-12" style={{ paddingBottom: '10px', paddingLeft: '0px' }}>
              <label style={{ fontWeight: 'bold' }}>{this.state.subheaderText}</label>
            </div>
          </div>
          <div style={{ background: 'white', textAlign: 'center', border: '1.1px solid lightgray', borderRadius: '16px', marginTop: '15px', width: '100%' }}>
            <Form>
              <div className="row" style={{ margin: '0px', position: 'relative' }}>
                <img className="imageStyle" src={require("../../assets/images/stage3New.png")}></img>
                <p onClick={() => { this.gotoStage2() }} className="backButton"><FontAwesomeIcon icon={faUndo} /></p>
              </div>
              <div className="row" style={{ margin: '10px auto', color: '#401663', width: '80%', fontWeight: 'bold', marginBottom: '0px', display: 'inline' }}>
                <p style={{ marginBottom: '10px' }}>How are you financing your move?</p>
              </div>
              <div className="row" style={{ margin: '0px', width: '80%', margin: '0 auto 30px' }}>
                <select style={{ top: '2px', fontSize: '14px', minHeight: '38px', width: '100%', paddingLeft: '.83333em', border: '1px solid lightgray', borderRadius: '12px' }} value={this.state.appState.whyPad.newCustomer.financingMove} name="financingMove" onChange={this.handleChange}>
                  <option value="">Please select an option</option>
                  <option value="Cash">Cash</option>
                  <option value="Mortgage & Deposit">Mortgage & Deposit</option>
                </select>
              </div>
              <div className="row" style={{ margin: '10px auto', color: '#401663', width: '80%', fontWeight: 'bold', marginBottom: '0px', display: 'inline' }}>
                <p style={{ fontSize: '14px', width: '80%', margin: '0 auto' }}>If you require a mortgage, would you like us to put you in touch with an adviser?</p>
              </div>
              <div className="row" style={{ margin: '0px', width: '80%', margin: '0 auto', color: 'rgb(64, 22, 99)' }}>
                {['checkbox'].map((type) => (
                  <div key={`default-${type}`} style={{ display: 'flex', marginTop: '20px', width: '100%' }}>
                    <Form.Check className="col-sm-4" style={{ marginBottom: '5px' }} type={type} id='1' label='Yes' checked={this.state.appState.whyPad.newCustomer.adviser === 1 ? true : false} name="adviser" value="1" onChange={this.handleChange} />
                    <Form.Check className="col-sm-4" style={{ marginBottom: '5px' }} type={type} id='2' label='No' checked={this.state.appState.whyPad.newCustomer.adviser === 2 ? true : false} name="adviser" value="2" onChange={this.handleChange} />
                    <Form.Check className="col-sm-4" style={{ marginBottom: '5px' }} type={type} id='3' label='Maybe' checked={this.state.appState.whyPad.newCustomer.adviser === 3 ? true : false} name="adviser" value="3" onChange={this.handleChange} />
                  </div>
                ))}
              </div>
              <div className="row" style={{ margin: '0px', width: '80%', margin: '0 auto', color: 'rgb(64, 22, 99)' }}>
                {['checkbox'].map((type) => (
                  <div key={`default-${type}`} style={{ display: 'flex', marginTop: '20px', width: '100%' }}>
                    <Form.Check className="col-sm-12" style={{ marginBottom: '5px' }} type={type} id='4' label='Would you like to receive property alerts from us?' checked={this.state.appState.whyPad.newCustomer.gdprConsent === 1 ? true : false} name="gdprConsent" value="1" onChange={this.handleChange} />
                  </div>
                ))}
              </div>
              <div style={{ width: '50%', margin: '40px auto 0px', borderRadius: '32px' }} className={this.state.nextButtonClass}>
                <div onClick={() => { this.submit() }} className="form-control" style={{ borderRadius: '32px', borderLeft: 'none', marginBottom: '20px', height: '50px', paddingTop: '10px', background: 'transparent' }}>
                  <a style={{ color: 'white', fontWeight: 'bold' }} type="button">{this.state.buttonText}</a>
                </div>
              </div>
            </Form>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default Stage3New;